import { Component, inject, OnInit } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { IconsService } from 'src/app/shared/services/icons.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-users',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Perfiles y roles</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-administration [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Administradores</h2>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-fill ms-3 me-3">
            <div class="input-group mb-3">
              <input class="form-control border-secondary border-end-0 rounded-start-3 bg-transparent" placeholder="Buscar..." [formControl]="search">
              <div class="input-group-append border border-secondary border-start-0 rounded-end-3 bg-transparent">
                <fa-icon [icon]="icons.faSearch" *ngIf="!search.value" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
                <fa-icon [icon]="icons.faTimes" *ngIf="search.value" (click)="clearSearch()" class="input-group-text bg-transparent border-0 mt-1"></fa-icon>
              </div>
            </div>
          </div>
          <div class="text-end">
            <button class="btn btn-zazz-dark ms-2 shadow-sm" routerLink="create" *ngIf="authService.hasPermission('can_create_users')">
              <fa-icon [icon]="icons.faPlus" class="me-0 me-md-2"></fa-icon>
              Agregar administrador
            </button>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">Nombre</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Correo</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr app-tr-user
                  [user]="user"
                  (updateData)="loadUsers(payload)"
                  *ngFor="let user of users | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"
                ></tr>
              </tbody>
            </table>
          </div>
          <div class="list-group-item text-center py-5" *ngIf="users.length==0&&loading">
            <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
            <p class="text-muted">Cargando...</p>
          </div>
          <div class="list-group-item text-center py-5" *ngIf="users.length==0&&!loading">
            <img src="/assets/images/empty-state.png" width="240px">
            <h5 class="text-muted">No se encontraron registros</h5>
          </div>
          <div class="list-group-item text-center pt-3" >
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
              *ngIf="users.length>0"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>

  `,
  styleUrls: []
})
export class UsersComponent implements OnInit {
  loading: boolean = false;
  users: any[] = [];
  meta: any = {};
  profile: any = {};
  searchBox: FormGroup = new FormGroup({});

  currentView: string = 'users';
  search: FormControl = new FormControl();

  payload: any = {
    page: 1,
    per_page: 10,
  };

  p: number = 1;
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public icons: IconsService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.payload.profile_id = this.profile.id;
  }

  ngOnInit() {    
    this.loadUsers(this.payload);

    this.search.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((term: string) => this.store.getUsers({
        name: term,
        tipo: this.payload.tipo,
        page: 1,
        per_page: this.payload.per_page,
        utility_id: this.profile.utility_id
      }))).subscribe((results: any) => {
        this.users = results.data;
        this.meta = results.meta;
      });
  }

  loadUsers(payload: any) {
    this.loading = true;
    this.store.getUsers(payload).subscribe({
      next: (users: any) => {
        console.log(users);
        this.users = users.data;
        this.meta = users.meta;
        this.loading = false;
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.warning('No se encontraron registros', 'Error');
        this.users = [];
        this.loading = false;
      }
    });
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadUsers(this.payload);
  }

  clearSearch() {
    delete this.payload.name;
    this.search.setValue(null);
    // this.loadSettlements(this.payload);
  }  
}
